export class Page<T> {
  totalPages = 0;
  totalElements = 0;
  pageNumber = 0;
  pageSize = 10;
  hasContent = false;
  hasNext = false;
  content: Array<T> = [];
}

export class HdOption {
  label: string;
  value: any;
  color?: string;
  hide?: boolean;
  /** 占据列数，默认 1，最大 4（一行共 4 列）；历史未传按 1 */
  width?: number;
  /**
   * 字段类型，默认文本。
   * `accessory`：附件图片，value 为图片地址 string / string[] 或 { name?, path?/url? }[]
   */
  type?: string;
  clickText?: string;
  click?: (value: any) => void;
  clickText1?: string;
  click1?: (value: any) => void;
  /**
   * 值后显示编辑笔图标（Figma edit/edit，14px）。
   */
  editable?: boolean;
  /** 点击编辑笔回调，供父组件处理（如弹窗改值） */
  edit?: (col?: HdOption) => void;
}

export class SelectOption {
  label: string;
  value: string;
  selectList?: Array<any>;
  selectListName?: string;
  showLabelAndValue?: boolean = false;
  hdDropdownMatchSelectWidth?: boolean = false;
  hdServerSearch?: boolean = false;
  hdShowItemCode?: boolean = false; // 是否用[value]label显示选项列表
  tableColumns?: Array<SelectOptionTableColumn>;
  hdShowSearch?: boolean = true;
  hdAllowClear?: boolean = true;
}

export class RadioOption {
  label: string;
  value: string;
  optionList?: Array<any>;
  showLabelAndValue?: boolean = false;
}

export class CheckboxOption {
  label: string;
  value: string;
  optionList?: Array<any>;
  showLabelAndValue?: boolean = false;
}

export class SelectOptionTableColumn {
  width: number;
  label: string; // 这里对应的是列名
  name: string; // 对应selectList里面的name值, 如果有render字段 则去render函数渲染
  icons?: Array<SelectOptionTableColumnIcon>; // 对应的图片名字
  render?: (value: any) => string;
}

export class SelectOptionTableColumnIcon {
  iconName: string;
  fieldName: string;
}

export class InputNumber {
  min?: number = 0;
  max?: number = 99999999;
  step?: number = 1;
  precision?: number = 4;
  nzFormatter?: Function;
  nzParser?: Function;
}

export interface CascaderShowSearchOptions {
  filter?: (inputValue: string, path: any[]) => boolean;
  sorter?: (a: any[], b: any[], inputValue: string) => number;
}

export class CascaderOption {
  options: Array<any>;
  /** 是否开启搜索，默认 true；传 false 关闭；传对象可自定义 filter/sorter */
  showSearch?: boolean | CascaderShowSearchOptions;
  /** 选项中拼音字段名，默认 pinyin */
  pinyinField?: string;
  /** 下拉菜单额外 class，默认 hd-cascader-menus */
  menuClassName?: string;
  /** 下拉菜单样式（对应 nzMenuStyle） */
  menuStyle?: { [key: string]: string };
  /**
   * 搜索结果下拉最小宽度（可选）。
   * number 按 px；string 可传 '360px' 等；不传则按文案自适应，不强制宽度
   */
  dropdownMinWidth?: number | string;
}
